export const isFile = (obj: unknown): obj is File => {
  return typeof obj === 'object' && obj !== null && obj instanceof File;
};
